<div class="success">
	<ng-content select="[header]"></ng-content>
	<bp-content color="white">
		<div class="success-content {{ getBgCssClass() }}">
			<ng-content select="[content]"></ng-content>
		</div>
	</bp-content>
</div>
